<template>
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clip-path="url(#clip0_1839_2439)">
      <path
        d="M5.572 0.164942C5.059 0.172942 4.639 0.605442 4.646 1.11794V4.81194H0.975C0.698 4.80844 0.4285 4.92644 0.2615 5.11244C0.0945 5.29844 0.022 5.52894 0.022 5.75244C0.022 5.97594 0.0945 6.20644 0.2615 6.39244C0.4285 6.57844 0.698 6.69644 0.975 6.69294H5.5865C6.1 6.69294 6.527 6.26644 6.527 5.75244V1.11794C6.534 0.593942 6.0955 0.156942 5.572 0.164942ZM10.3985 0.153442C9.885 0.161442 9.4645 0.594942 9.4725 1.10844V5.71794C9.4725 6.23144 9.8995 6.65844 10.413 6.65844H15.0465C15.3235 6.66244 15.593 6.54394 15.76 6.35744C15.9275 6.17194 16 5.94144 16 5.71794C16 5.49444 15.9275 5.26394 15.7605 5.07744C15.5935 4.89194 15.324 4.77394 15.047 4.77744H11.354V1.10844C11.362 0.583442 10.9235 0.144942 10.3985 0.153442ZM10.4135 9.30644C9.9 9.30644 9.4735 9.73344 9.473 10.2469V14.8804C9.4695 15.1574 9.5875 15.4269 9.7735 15.5939C9.9595 15.7609 10.19 15.8334 10.4135 15.8334C10.637 15.8334 10.8675 15.7604 11.0535 15.5939C11.2395 15.4274 11.3575 15.1574 11.354 14.8804V11.1874H15.024C15.301 11.1914 15.5705 11.0729 15.7375 10.8869C15.9045 10.7009 15.977 10.4704 15.977 10.2469C15.977 10.0234 15.904 9.79294 15.7375 9.60694C15.5705 9.42094 15.301 9.30294 15.024 9.30644H10.4135ZM0.953 9.34094C0.676 9.33694 0.4065 9.45544 0.2395 9.64094C0.0725 9.82694 0 10.0574 0 10.2814C0 10.5054 0.0725 10.7354 0.2395 10.9209C0.4065 11.1074 0.676 11.2254 0.953 11.2219H4.646V14.8924C4.6425 15.1694 4.7605 15.4389 4.9465 15.6059C5.1325 15.7734 5.363 15.8459 5.5865 15.8459C5.81 15.8459 6.0405 15.7729 6.2265 15.6059C6.4125 15.4389 6.5305 15.1694 6.527 14.8924V10.2814C6.527 9.76794 6.1 9.34094 5.5865 9.34094H0.953Z"
        fill="#FFAE00"
      />
    </g>
    <defs>
      <clipPath id="clip0_1839_2439">
        <rect width="16" height="16" fill="white" />
      </clipPath>
    </defs>
  </svg>
</template>

<script lang="ts">
export default {};
</script>
